@if (showPlaceholder) {
  <div class="placeholder-wrapper">
    <div class="loading-placeholder" [class.dark-bg]="darkBg"></div>
  </div>
}

@if (!showPlaceholder) {
  <ng-content></ng-content>
}
